import React from 'react';
import TableHeader from '@/components/TableHeader';
import MainTable from './components/MainTable';
import useReactRouter from 'atv-use-react-router';
import styles from './index.module.scss';

function EventList() {
  const { history } = useReactRouter();
  const handleAddBtnClick = () => {
    history.push('/events/new');
  };
  return (
    <div className={styles.page}>
      <TableHeader name="大赛动态" onAddBtnClick={handleAddBtnClick} />
      <div className={styles.mainTable}>
        <MainTable />
      </div>
    </div>
  );
}

export default EventList;
